import React from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";
import Button from "../Button/Button";
import FooterBottom from "../FooterBottom/FooterBottom";
import useTranslate from "../../hooks/useTranslate";

const Footer = () => {
  const { translate, language } = useTranslate();
  const isFa = language === "fa";

  return (
    <div>
      <div className={`footer footer--home ${isFa ? "rtl-mode" : "ltr-mode"}`} id="contacts">
        <div className="footer__contact flex__center">
          <h2>{translate("home.journey.heading")}</h2>
          <p>{translate("home.journey.intro")}</p>
          <Link to="/contact-us">
            <Button className="footer__button">{translate("footer3")}</Button>
          </Link>
        </div>
      </div>
      <FooterBottom />
    </div>
  );
};
export default Footer;
